// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1Lw5F","img":"PageLoading_img__2NX4J","fail":"PageLoading_fail__ON60b","desc":"PageLoading_desc__16XjG","title":"PageLoading_title__tEnKX"};